import {useTranslation} from 'react-i18next';
import EventLineV4 from './EventLineV4';
import EventRowItemV4 from './EventRowItemV4';
import Text from '../../common/component/Text';
import {IRewardProgressBarV4} from '../type';

interface IProps {
  progressBar: IRewardProgressBarV4;
}

export default function RewardProgressBarV4({progressBar}: IProps) {
  const {t} = useTranslation();
  const {isComplete, currentValue, maxValue} = progressBar;

  return (
    <>
      <EventRowItemV4
        className="gap-x-10"
        leftElement={
          <Text className="s14-bold-white leading-19 tracking-[-0.4px]">
            {t(
              isComplete
                ? 'crm_attendance_status_participated'
                : currentValue === 0
                  ? 'crm_attendance_status_not_participated'
                  : 'crm_attendance_status_participating'
            )}
          </Text>
        }
        rightElement={
          <Text className="s14-regular-white leading-19 tracking-[-0.4px]">
            {t('crm_attendance_status_count', {
              count: currentValue,
              max: maxValue,
            })}
          </Text>
        }
      />
      <EventLineV4 className="my-15 opacity-10" />
    </>
  );
}
